import styled from 'styled-components'
import {Col} from 'antd'
import { device } from '../../styles/devices';

export const StyleHeader=styled.header`
width:100%;
position:fixed;
background:#fff;
z-index:1;
box-sizing: border-box;
`;

export const FlexDiv=styled.div`
display: flex;
flex-direction:${props => props.column ? "column" : "row"};
justify-content:${props => props.spaceAround? "space-around" : "center"};
align-items: center;
box-sizing: border-box;
`
export const DivUser=styled(FlexDiv)` 
`
export const TituloEmpresa = styled.h1`
  font-size: 15px;
  text-align: center;
  letter-spacing:2px;
  color: black;
  margin:0;
  padding:0;
  font-weight:400;
  color:#3261fb;
  font-family: 'Poiret One', cursive;
  width:90%
  display:none
  @media ${device.laptop} { 
    font-size: 25px;
    display:block;
  }
  @media ${device.desktop} { 
    font-size: 25px;
    display:block;
  }

`;

export const ColFlex= styled(Col)`
  display:flex;
  justify-content:center;
  align-items:center;
  box-sizing: border-box;
  height: 100px;
`;

export const ColFlexCenter= styled(ColFlex)`
  justify-content:center;
`;

export const ColFlexEnd= styled(ColFlex)`
  justify-content:flex-end;
`;